/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TenantConfigurationManagementOptions {
    getFixupPrototypeFunction() { return TenantConfigurationManagementOptions.fixupPrototype; }

    static newInstance(model: Partial<TenantConfigurationManagementOptions>): TenantConfigurationManagementOptions {
        let obj = Object.assign(new TenantConfigurationManagementOptions(), model);
        TenantConfigurationManagementOptions.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TenantConfigurationManagementOptions>): TenantConfigurationManagementOptions {
        if (!model) return null;
        return TenantConfigurationManagementOptions.newInstance(<TenantConfigurationManagementOptions> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TenantConfigurationManagementOptions) {
        if (!obj) return;

        models.TenantConfigurationManagementOptions.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TenantConfigurationManagementOptions): boolean {
        Object.setPrototypeOf(obj, TenantConfigurationManagementOptions.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.inventory) {
            models.InventoryConfigurationManagement.fixupPrototype(this.inventory);
        }
        if (this.policy) {
            models.PolicyConfigurationManagement.fixupPrototype(this.policy);
        }
    }

    /**
     * Inventory configuration management options
     */
    inventory: models.InventoryConfigurationManagement;

    /**
     * Policy configuration management options
     */
    policy: models.PolicyConfigurationManagement;

}
